/**
 * @desc 订单详情
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(params: API.omsFlow.systemOrder.getOrderDetail.Params, options?: any) {
  return updateResponse(
    http(URL + `/systemOrder/getOrderDetail`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
